import { useEffect, useState } from "react";
import styles from "./AdminTaxas.module.css";
import Header from "../../components/Header/Header";
import AdminSideBar from "../../components/SideBar/SideBar";
import Footer from "../../components/footer/Footer";
import Taxas from "../../components/Taxas"
import Seta from '../../assets/SetaDireita.svg'
import { useTranslation } from "react-i18next";
import api from "../../utils/axios/api";

function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    const listener = () => {
      setMatches(media.matches);
    };

    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [matches, query]);

  return matches;
}

export default function MeusProdutos() {
  const [taxaGeral, setTaxaGeral] = useState<number>(0);
  const [taxaGeralId, setTaxaGeralId] = useState<string | null>(null);

  const isSmallScreen = useMediaQuery('(max-width: 768px)');
  const [mobileMenuActive, setMobileMenuActive] = useState(false);

  // Esta função alterna o estado do menu móvel
  const toggleMobileMenu = () => {
    setMobileMenuActive(mobileMenuActive);
  };


  const { t } = useTranslation("translation", { keyPrefix: "admintaxas" })

  //GET: taxas
  useEffect(() => {
    async function loadTaxas() {
      try {
        const response = await api.get(`/admin/fees`);

        const taxaGeralIdx = response.data.findIndex((item: any) => item.name === 'Taxa de venda geral')

        if(taxaGeralIdx < 0) return
        
        setTaxaGeralId(response.data[taxaGeralIdx].id)
        setTaxaGeral(response.data[taxaGeralIdx].value)


      } catch (error) {
        console.error("Error fetching taxas:", error);
      }
    }
    loadTaxas();
  }, []);

  // Função para lidar com mudanças na taxa
  const handleTaxaChange = (newValue: number) => {
    setTaxaGeral(newValue)
    // try {
    //   // Faça a chamada à API para atualizar o valor da taxa no backend
    //   const response = await api.put(`/fee/${taxas[index].id}`, { value: newValue });
    //   console.log(taxas)

    //   // Se a API retornar sucesso, atualize o estado local
    //   if (response.status === 200) {
    //     setTaxas((prevTaxas) =>
    //       prevTaxas.map((taxa, i) =>
    //         i === index ? { ...taxa, value: newValue } : taxa
    //       )
    //     );
    //   } else {
    //     console.error("Erro ao atualizar a taxa: Status não é 200");
    //   }
    // } catch (error) {
    //   console.error("Erro ao atualizar a taxa:", error);
    //   alert("Erro ao atualizar a taxa.");
    // }
  };

  const handleSalvar = async () => {
    console.log(taxaGeralId)
    try {
      if (taxaGeralId) {
        await api.put(`/admin/fees/${taxaGeralId}`, { value: taxaGeral })
      }
      else {
        const response = await api.post('/admin/fees', {
          name: 'Taxa de venda geral',
          value: taxaGeral
        })
        setTaxaGeralId(response.data.id)
      }

      alert("Taxas atualizadas com sucesso!");
    } catch (error) {
      console.error("Error updating taxas:", error);
      alert("Erro ao atualizar taxas.");
    }
  };

  return (
    <>
      <Header
        boxShadow
        toggleMobileMenu={toggleMobileMenu}
        mobileMenuActiveState={mobileMenuActive}
        isSmallScreen={isSmallScreen}
      />
      <main className={styles.mainContainer}>
        <section className={styles.sectionContainer}>


          <div className={styles.caminho}>
            <div className={styles.item}>
              <a href="/">{t('minhaconta')}</a>
            </div>
            <div className={styles.img_seta}>
              <img src={Seta} alt="seta" />
            </div>
            <div className={styles.local}>
              <span>{t('taxas')}</span>
            </div>
          </div>

          <div className={styles.tituloContainer}>
            <p className={styles.titulo}>{t('taxas')}</p>
          </div>

          <div className={styles.taxa}>
            <div>
              <p className={styles.texto}>{t('geral')}</p>
            </div>
            <div>
              <Taxas
                onChange={handleTaxaChange}
                initialValue={taxaGeral}
              />
            </div>
          </div>

          <button
            className={styles.buttonProduto}
            onClick={handleSalvar}
          >
            {t('salvar')}
          </button>


        </section>
        <aside className={styles.asideContainer}>
          <AdminSideBar />
        </aside>
      </main>
      {!isSmallScreen && (<Footer />)}
    </>
  )
}